module.exports = __webpack_public_path__ + "img/radiobutton.47382caf.svg";